const getMeta = ({ title, metaTitle, description, metaDescription, ...x }) => {
	const isSection = !!x.switcherData
	const prefix = isSection ? `${x.switcherData.label} | ` : ''

	return {
		...x,
		title: `${prefix}${metaTitle || title}`,
		description: `${prefix}${metaDescription || description}`,
	}
}

export default getMeta
